module.exports = __webpack_public_path__ + "assets/img/page4-first-tab-neutral-de241a87.png";